import HttpResponse from "../../../../../../utils/http/http.response";

export enum OrderCargoOrderFinishedListResponseItemPublicStatus {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
  PUBLISHED = "PUBLISHED",
}

type OrderCargoOrderFinishedListResponseItemProducer = {
  id: string | null;
  name: string;
};

type OrderCargoOrderFinishedListResponseItemConsumer = {
  id: string | null;
  name: string;
};

type OrderCargoOrderFinishedListResponseItemAttentions = {
  newSharedPost: boolean;
  newPlanEntryPost: boolean;
  cargoOrderEdit: boolean;
  cargoOrderCancel: boolean;
};

export type OrderCargoOrderFinishedListResponseDataItem = {
  id: string;
  startTime: Date;
  humanId: number;
  isCancelled: boolean;
  publicStatus: OrderCargoOrderFinishedListResponseItemPublicStatus;
  rideAddresses: (string | string[])[];
  passengers: string[];
  dispatch: string;
  consumer: OrderCargoOrderFinishedListResponseItemConsumer | null;
  producer: OrderCargoOrderFinishedListResponseItemProducer;
  drivers: string[];
  externalId: string | null;
  attentions: OrderCargoOrderFinishedListResponseItemAttentions;
  slkStatus: boolean | null;
};

type OrderCargoOrderFinishedListResponse = HttpResponse<{
  data: OrderCargoOrderFinishedListResponseDataItem[];
  totalCount: number | null;
}>;

export default OrderCargoOrderFinishedListResponse;
